export default function MinusIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 2) / 11)}
        viewBox='0 0 11 2'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.916992 1C0.916992 0.585786 1.25278 0.25 1.66699 0.25H10.0003C10.4145 0.25 10.7503 0.585786 10.7503 1C10.7503 1.41421 10.4145 1.75 10.0003 1.75H1.66699C1.25278 1.75 0.916992 1.41421 0.916992 1Z'
        />
      </svg>
    </span>
  );
}
